<script>
import appConfig from "@src/app.config";

export default {
  components: {},
  data: function() {
    return {
      appConfig: appConfig
    };
  }
};
</script>

<template>
  <div class="pt-5p">
    <div class="container">
      <slot />
    </div>
    <footer class="footer footer-alt">
      <span class="footer-text" v-if="appConfig.empresa != 'sisloc'">
        Copyright 2020 © {{ appConfig.company }}. Todos os direitos reservados.
      </span>
    </footer>
  </div>
</template>
